var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"components custimer-service-btn"},[(_vm.type == 0)?_c('img',{staticClass:"img",attrs:{"src":require('@/assets/img/mg_kf.png')},on:{"click":_vm.toCs}}):(_vm.type == 1)?_c('img',{staticClass:"img",attrs:{"src":require('@/assets/img/mg-kf-index.png')},on:{"click":_vm.toCs}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }